import { render } from "./UserFamilyMembers.vue?vue&type=template&id=2f86f4d3"
import script from "./UserFamilyMembers.vue?vue&type=script&lang=js"
export * from "./UserFamilyMembers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__